
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.498 3.5V2M8.62 4.377l1.06-1.06M3.316 9.68l1.06-1.06M3.32 3.316l1.06 1.06M2 6.498h1.5M14.879 8.96l-2.581 1.695 2.728 2.624L13.364 15l-2.749-2.644-1.658 2.526L5.997 6z"}})])
          )
        }
      }
    